import { gql } from "@apollo/client";

export const digitalGoodFragment = gql`
    fragment DigitalGood on DigitalGood {
        sku
        type
        consumableQuantity
        priceTier
        title
        description
        localizationsList {
            locale
            title
            description
        }
        status
        lensId
    }
`;
